module.exports = __webpack_public_path__ + "img/icon-comment.3b6531cf.png";